var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Employee Lookup")]),_c('h2',[_c('lea-display',{attrs:{"lea":_vm.selectedLea}})],1),_c('employee-search-widget',{attrs:{"selected-lea":_vm.selectedLea}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }